<template>
  <div class="flex items-center h-full">
    <span class="sensitive text-sm text-gray-700">{{ params.data?.provider_name || '-' }}</span>
  </div>
</template>

<script>
export default {
  name: 'Quality_ProviderCell',
  props: ['params']
};
</script>
